/// <amd-module name="Artifacts/Root/helpers/BadgeHelper" />
import { FeedServiceInstanceId } from "Artifacts/Root/Constants";
import { generateServiceRestApiUri, IRestApiRoutes } from "Artifacts/Root/utils/RestApi";
import { IVssPageContext } from "VSS/Platform/Context";
import { getServiceLocation } from "VSS/Platform/Location";
import * as Url from "VSS/Platform/Util/Url";

const PackagingArea = "Packaging";

const PackageBadgeLocation: IRestApiRoutes = {
  locationId: "61D885FD-10F3-4A55-82B6-476D866B673F",
  resource: "Badge",
  routeTemplate: "public/{area}/Feeds/{feedId}/Packages/{packageId}/{resource}",
};

export class Badge {
  // TODO: this should be coming from another webproj, not required in initial page load
  // when Enable badges is set in feed settings, create badge button will show up in hub
  public static getPackageBadgeRestUri(
    pageContext: IVssPageContext,
    feedId: string,
    packageId: string,
    projectId: string | null,
    publicAccessMapping: string,
  ): Url.Uri {
    const path = Url.replaceRouteValues(PackageBadgeLocation.routeTemplate, {
      area: PackagingArea,
      feedId,
      packageId,
      resource: PackageBadgeLocation.resource,
    });

    const packagingServiceRootPath = getServiceLocation(pageContext, FeedServiceInstanceId);
    if (!packagingServiceRootPath.startsWith("http://") && !packagingServiceRootPath.startsWith("https://")) {
      //IE10 and older versions do not support window.location.origin
      const baseUrl = window.location.origin || (window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : ''));
      return generateServiceRestApiUri(baseUrl + packagingServiceRootPath, path, false, projectId);
    }

    return generateServiceRestApiUri(packagingServiceRootPath, path, false, projectId);
  }
}
